export default __webpack_public_path__ + "static/banner-2-371b5cec772b7041d11d9c17b51b7447.jpg";